import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import activityOptions from '@/stakeholders/utils/activity-options'
import attitudeOptions from '@/stakeholders/utils/attitude-options'
import ProjectStakeholder from '@/diagrams/models/project-stakeholder'
import Match from '@/diagrams/models/match'

@Component
export default class EditStakeholder extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({ default: false })
  private archived!: boolean

  private activityOptions = activityOptions
  private attitudeOptions = attitudeOptions

  private createNode(evt: CreateNodeEvent): ProjectStakeholder {
    const model = new ProjectStakeholder()
    model.projectId = evt.project.id
    model.groupId = evt.parent.dbId
    return model
  }

  private selectNode(stakeholder: ProjectStakeholder, match: Match): ProjectStakeholder {
    stakeholder.name = match.name
    stakeholder.stakeholderId = match.stakeholderId
    stakeholder.role = match.role
    stakeholder.region = match.region
    if (match.keywords) {
      stakeholder.keywords = match.keywords
    }
    return stakeholder
  }
}
